import { render, staticRenderFns } from "./AmisDemo.vue?vue&type=template&id=0eb97cf8"
import script from "./AmisDemo.vue?vue&type=script&lang=js"
export * from "./AmisDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports